<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端（原样不动） ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <div class="search-bar">
          <el-input
            v-model="searchParams.name"
            placeholder="请输入擂台赏名称"
            clearable
            style="width: 220px; margin-right: 10px"
          ></el-input>

          <el-select
            v-model.number="searchParams.cate_id"
            placeholder="请选择擂台赏分类"
            style="width: 180px; margin-right: 10px"
          >
            <el-option
              v-for="item in cateList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>

          <el-button type="primary" icon="el-icon-search" @click="getList"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" @click="resetSearch"
            >重置</el-button
          >
          <el-button type="success" icon="el-icon-plus" @click="handleAdd"
            >添加擂台赏</el-button
          >

          <el-popover
            placement="bottom"
            title="显示列筛选"
            trigger="click"
            width="220"
          >
            <el-checkbox-group v-model="checkedColumns">
              <el-checkbox
                v-for="item in columnOptions"
                :key="item.prop"
                :label="item.prop"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
            <div style="text-align: right; margin-top: 8px">
              <el-button size="mini" @click="handleCheckAll">全选</el-button>
              <el-button size="mini" @click="handleClearAll">清空</el-button>
            </div>
            <el-button slot="reference" icon="el-icon-s-tools" type="info"
              >列筛选</el-button
            >
          </el-popover>
        </div>

        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
          @row-click="handleRowClick"
        >
          <el-table-column
            label="ID"
            prop="id"
            width="80"
            align="center"
            v-if="checkedColumns.includes('id')"
          />
          <el-table-column
            label="擂台赏名称"
            prop="name"
            min-width="180"
            v-if="checkedColumns.includes('name')"
          />
          <el-table-column
            label="擂台赏图片"
            width="120"
            align="center"
            v-if="checkedColumns.includes('image')"
          >
            <template slot-scope="scope">
              <img
                :src="scope.row.image"
                style="width: 60px; height: 60px; object-fit: cover"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="价格"
            prop="price"
            width="100"
            align="center"
            v-if="checkedColumns.includes('price')"
          />
          <el-table-column
            label="分类名称"
            prop="cate_name"
            width="120"
            align="center"
            v-if="checkedColumns.includes('cate_name')"
          />
          <el-table-column
            label="销量"
            prop="sales"
            width="100"
            align="center"
            v-if="checkedColumns.includes('sales')"
          />
          <el-table-column
            label="空车数"
            prop="empty_num"
            width="100"
            align="center"
            v-if="checkedColumns.includes('empty_num')"
          />
          <el-table-column
            label="串数"
            prop="bunch_num"
            width="100"
            align="center"
            v-if="checkedColumns.includes('bunch_num')"
          />
          <el-table-column
            label="收入"
            prop="income"
            width="100"
            align="center"
            v-if="checkedColumns.includes('income')"
          />
          <el-table-column
            label="支出"
            prop="pay"
            width="100"
            align="center"
            v-if="checkedColumns.includes('pay')"
          />
          <!-- 新增利润列 -->
          <el-table-column
            label="利润"
            width="120"
            align="center"
            v-if="checkedColumns.includes('profit')"
          >
            <template slot-scope="scope">
              <span v-if="Number(scope.row.income) === 0">--</span>
              <span
                v-else
                :style="{
                  color:
                    scope.row.income - scope.row.pay >= 0
                      ? '#00c48c'
                      : '#f56c6c',
                }"
              >
                {{
                  (
                    ((scope.row.income - scope.row.pay) / scope.row.income) *
                    100
                  ).toFixed(2)
                }}%
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="排序"
            prop="sort"
            width="80"
            align="center"
            v-if="checkedColumns.includes('sort')"
          />

          <el-table-column
            label="定制人ID"
            prop="custom_user_id"
            width="100"
            align="center"
            v-if="checkedColumns.includes('custom_user_id')"
          />

          <el-table-column
            label="剩余时间"
            width="180"
            align="center"
            v-if="checkedColumns.includes('remainText')"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.remainText }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="定制开始"
            prop="custom_start"
            width="180"
            align="center"
            v-if="checkedColumns.includes('custom_start')"
          />
          <el-table-column
            label="定制结束"
            prop="custom_end"
            width="180"
            align="center"
            v-if="checkedColumns.includes('custom_end')"
          />

          <el-table-column
            label="状态"
            width="180"
            align="center"
            v-if="checkedColumns.includes('status')"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-text="上架"
                inactive-text="下架"
                :active-value="1"
                :inactive-value="0"
                @click.native.stop
                @change="handleStatusChange(scope.row)"
              />
            </template>
          </el-table-column>

          <el-table-column
            label="创建时间"
            prop="created_at"
            width="180"
            v-if="checkedColumns.includes('created_at')"
          />
          <el-table-column
            label="更新时间"
            prop="updated_at"
            width="180"
            v-if="checkedColumns.includes('updated_at')"
          />

          <el-table-column
            label="操作"
            width="320"
            align="center"
            fixed="right"
            v-if="checkedColumns.includes('action')"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click.stop="handleEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-box"
                @click.stop="openPrizeDialog(scope.row)"
                >赏品</el-button
              >
              <el-button
                type="text"
                icon="el-icon-refresh"
                style="color: #67c23a"
                @click.stop="openRenewBox(scope.row)"
                >续箱</el-button
              >
              <el-button
                type="text"
                icon="el-icon-document"
                style="color: #409eff"
                @click.stop="openDrawRecord(scope.row)"
                >抽奖记录</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC 添加/编辑弹窗 -->
        <el-dialog
          :title="dialogType == 'add' ? '添加擂台赏' : '编辑擂台赏'"
          :visible.sync="dialogVisible"
          width="750px"
          @close="resetForm"
          append-to-body
        >
          <el-form
            :model="form"
            :rules="addRules"
            ref="formRef"
            label-width="120px"
          >
            <el-form-item label="擂台赏名称" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入名称"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="分类" prop="cate_id">
              <el-select
                v-model.number="form.cate_id"
                placeholder="请选择分类"
                style="width: 320px"
              >
                <el-option
                  v-for="item in cateList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="图片" prop="image">
              <div style="display: flex; align-items: center; gap: 12px">
                <el-button
                  type="primary"
                  icon="el-icon-picture"
                  @click="openImageDialog"
                  >选择图片</el-button
                >
                <div
                  v-if="form.image"
                  style="
                    border: 1px solid #eee;
                    padding: 4px;
                    border-radius: 4px;
                  "
                >
                  <img
                    :src="form.image"
                    style="
                      width: 52px;
                      height: 52px;
                      object-fit: cover;
                      display: block;
                    "
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="价格" prop="price">
              <el-input
                v-model="form.price"
                placeholder="请输入价格"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="卡册门票ID" prop="goods_id">
              <el-input
                v-model.number="form.goods_id"
                placeholder="请输入卡册门票ID（数字）"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input
                v-model="form.sort"
                placeholder="请输入排序值"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="空车数" prop="empty_num">
              <el-input
                v-model="form.empty_num"
                placeholder="请输入空车数"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="串值" prop="bunch_num">
              <el-input
                v-model="form.bunch_num"
                placeholder="请输入串值"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="定制人ID">
              <el-input
                v-model="form.custom_user_id"
                placeholder="可选"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="定制天数">
              <el-input
                v-model="form.custom_days"
                placeholder="可选"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="定制开始时间">
              <el-date-picker
                v-model="form.custom_start"
                type="datetime"
                placeholder="选择时间"
                style="width: 320px"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="定制结束时间">
              <el-date-picker
                v-model="form.custom_end"
                type="datetime"
                placeholder="选择时间"
                style="width: 320px"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="endPickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitForm">确认提交</el-button>
          </div>
        </el-dialog>

        <!-- PC 续箱弹窗 -->
        <el-dialog
          title="擂台续箱"
          :visible.sync="renewBoxVisible"
          width="500px"
          append-to-body
        >
          <el-form
            :model="renewBoxForm"
            ref="renewBoxRef"
            label-width="100px"
            size="medium"
          >
            <el-form-item label="擂台ID">
              <el-input v-model="renewBoxForm.box_id" disabled />
            </el-form-item>
            <el-form-item label="擂台名称">
              <el-input v-model="renewBoxForm.box_name" disabled />
            </el-form-item>
            <el-form-item label="续箱数量" prop="num">
              <el-input
                v-model.number="renewBoxForm.num"
                type="number"
                placeholder="请输入续箱数量"
                min="1"
                style="width: 200px"
              />
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button @click="renewBoxVisible = false">取消</el-button>
            <el-button type="primary" @click="submitRenewBox"
              >确认续箱</el-button
            >
          </div>
        </el-dialog>

        <!-- PC 图片选择弹窗 -->
        <el-dialog
          title="选择图片"
          :visible.sync="imageDialogVisible"
          width="850px"
          append-to-body
        >
          <div
            v-loading="imageLoading"
            element-loading-text="图片加载中..."
            style="padding: 10px"
          >
            <div
              style="
                display: flex;
                gap: 10px;
                margin-bottom: 15px;
                align-items: center;
              "
            >
              <el-select
                v-model.number="imageSearch.type"
                placeholder="图片类型"
                style="width: 180px"
                clearable
              >
                <el-option
                  v-for="item in image_type"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="getImageList"
                >筛选</el-button
              >
              <el-button icon="el-icon-refresh" @click="resetImageSearch"
                >重置</el-button
              >
            </div>
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                gap: 12px;
                max-height: 420px;
                overflow-y: auto;
                padding: 5px;
              "
            >
              <div
                v-for="img in imageList"
                :key="img.id"
                @click="selectImage(img)"
                style="
                  cursor: pointer;
                  padding: 4px;
                  border-radius: 6px;
                  text-align: center;
                "
                :style="{
                  border:
                    selectedImageUrl == img.url
                      ? '2px solid #1989fa'
                      : '2px solid transparent',
                  background:
                    selectedImageUrl == img.url ? '#f0f7ff' : 'transparent',
                }"
              >
                <img
                  :src="img.url"
                  style="
                    width: 100px;
                    height: 100px;
                    object-fit: cover;
                    border-radius: 4px;
                    display: block;
                  "
                />
                <span
                  style="
                    font-size: 12px;
                    margin-top: 4px;
                    color: #666;
                    display: block;
                  "
                  >{{ getImageTypeName(img.type) }}</span
                >
              </div>
            </div>
            <el-pagination
              @size-change="handleImageSizeChange"
              @current-change="handleImageCurrentChange"
              :current-page="imageSearch.page"
              :page-size="imageSearch.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="imageTotal"
              style="margin-top: 15px; text-align: right"
            ></el-pagination>
          </div>
          <div slot="footer">
            <el-button @click="imageDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="confirmSelectImage"
              >确认选择</el-button
            >
          </div>
        </el-dialog>

        <!-- PC 详情弹窗 -->
        <el-dialog
          :title="detailRow ? `${detailRow.name} 的详情` : '详情'"
          :visible.sync="detailDialogVisible"
          width="850px"
          append-to-body
          :close-on-click-modal="false"
        >
          <div
            class="detail-content"
            v-loading="detailLoading"
            element-loading-text="加载详情中..."
          >
            <div v-if="detailRow" style="padding: 10px 0">
              <div
                style="display: flex; align-items: center; margin-bottom: 20px"
              >
                <img
                  :src="detailRow.image"
                  style="
                    width: 100px;
                    height: 100px;
                    object-fit: cover;
                    border-radius: 6px;
                  "
                />
                <div style="margin-left: 16px">
                  <h2 style="margin: 0; font-size: 18px">
                    {{ detailRow.name }}
                  </h2>
                  <p style="margin: 5px 0 0; color: #666">
                    ID：{{ detailRow.id }}
                  </p>
                </div>
              </div>
              <el-descriptions :column="2" border size="small">
                <el-descriptions-item label="名称">{{
                  detailRow.name
                }}</el-descriptions-item>
                <el-descriptions-item label="分类">{{
                  detailRow.cate_name
                }}</el-descriptions-item>
                <el-descriptions-item label="价格">{{
                  detailRow.price
                }}</el-descriptions-item>
                <el-descriptions-item label="销量">{{
                  detailRow.sales
                }}</el-descriptions-item>
                <el-descriptions-item label="空车数">{{
                  detailRow.empty_num
                }}</el-descriptions-item>
                <el-descriptions-item label="串数">{{
                  detailRow.bunch_num
                }}</el-descriptions-item>
                <el-descriptions-item label="收入">{{
                  detailRow.income
                }}</el-descriptions-item>
                <el-descriptions-item label="支出">{{
                  detailRow.pay
                }}</el-descriptions-item>
                <el-descriptions-item label="利润">
                  <span v-if="Number(detailRow.income) === 0">--</span>
                  <span
                    v-else
                    :style="{
                      color:
                        detailRow.income - detailRow.pay >= 0
                          ? '#00c48c'
                          : '#f56c6c',
                    }"
                  >
                    {{
                      (
                        ((detailRow.income - detailRow.pay) /
                          detailRow.income) *
                        100
                      ).toFixed(2)
                    }}%
                  </span>
                </el-descriptions-item>
                <el-descriptions-item label="排序">{{
                  detailRow.sort
                }}</el-descriptions-item>
                <el-descriptions-item label="定制人ID">{{
                  detailRow.custom_user_id || "无"
                }}</el-descriptions-item>
                <el-descriptions-item label="定制天数">{{
                  detailRow.custom_days || "无"
                }}</el-descriptions-item>
                <el-descriptions-item label="定制开始">{{
                  detailRow.custom_start || "无"
                }}</el-descriptions-item>
                <el-descriptions-item label="定制结束">{{
                  detailRow.custom_end || "无"
                }}</el-descriptions-item>
                <el-descriptions-item label="状态">
                  <span
                    :style="{
                      color: detailRow.status == 1 ? '#00C48C' : '#F56C6C',
                    }"
                    >{{ detailRow.status == 1 ? "上架" : "下架" }}</span
                  >
                </el-descriptions-item>
                <el-descriptions-item label="创建时间">{{
                  detailRow.created_at
                }}</el-descriptions-item>
                <el-descriptions-item label="更新时间">{{
                  detailRow.updated_at
                }}</el-descriptions-item>
              </el-descriptions>
            </div>
          </div>
          <div slot="footer">
            <el-button @click="detailDialogVisible = false">关闭</el-button>
          </div>
        </el-dialog>

        <!-- PC 盲盒赏品列表弹窗 -->
        <el-dialog
          title="盲盒赏品管理"
          :visible.sync="prizeDialogVisible"
          width="1500px"
          append-to-body
          close-on-click-modal="false"
        >
          <div style="margin-bottom: 15px; display: flex; gap: 10px">
            <el-input
              v-model="prizeSearch.box"
              placeholder="箱数"
              style="width: 180px"
            ></el-input>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="getPrizeList"
              >搜索</el-button
            >
            <el-button icon="el-icon-refresh" @click="resetPrizeSearch"
              >重置</el-button
            >
            <el-button
              type="success"
              icon="el-icon-plus"
              @click="openGoodsDialog"
              >添加赏品</el-button
            >
          </div>
          <div style="margin-bottom: 25px">
            <p style="font-weight: bold; margin-bottom: 8px">
              待提交赏品（未保存）
            </p>
            <el-table
              :data="tempSelectedPrize"
              border
              stripe
              size="small"
              style="width: 100%"
            >
              <el-table-column
                label="商品ID"
                prop="goods_id"
                width="100"
                align="center"
              />
              <el-table-column label="商品图片" width="100" align="center">
                <template slot-scope="scope">
                  <img
                    :src="scope.row.image"
                    style="width: 60px; height: 60px; object-fit: cover"
                  />
                </template>
              </el-table-column>
              <el-table-column label="商品名称" prop="title" min-width="220" />
              <el-table-column
                label="等级ID"
                prop="level_id"
                width="90"
                align="center"
              />
              <el-table-column label="等级名称" width="140" align="center">
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.level_id"
                    size="mini"
                    placeholder="选择等级"
                  >
                    <el-option
                      v-for="item in levelList"
                      :key="item.level_id"
                      :label="item.name"
                      :value="item.level_id"
                    />
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column label="原始数量" width="110" align="center">
                <template slot-scope="scope">
                  <el-input
                    v-model.number="scope.row.num"
                    type="number"
                    size="mini"
                    placeholder="数量"
                    min="1"
                  />
                </template>
              </el-table-column>

              <el-table-column label="概率(%)" width="110" align="center">
                <template slot-scope="scope">
                  <el-input
                    v-model.number="scope.row.probability"
                    type="number"
                    size="mini"
                    placeholder="概率"
                    :min="0"
                    :max="100"
                  />
                </template>
              </el-table-column>

              <el-table-column label="价格" width="120" align="center">
                <template slot-scope="scope">
                  <el-input
                    v-model.number="scope.row.price"
                    type="number"
                    size="mini"
                    placeholder="价格"
                  />
                </template>
              </el-table-column>
              <el-table-column label="兑换价格" width="120" align="center">
                <template slot-scope="scope">
                  <el-input
                    v-model.number="scope.row.recovery_price"
                    type="number"
                    size="mini"
                    placeholder="兑换价"
                  />
                </template>
              </el-table-column>
              <el-table-column label="商品类型" width="140" align="center">
                <template slot-scope="scope">
                  {{ scope.row.goods_type == 1 ? "真实赏品" : "虚拟赏品" }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    icon="el-icon-delete"
                    @click="delTempPrize(scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div>
            <div style="font-weight: bold; margin-bottom: 8px">
              已保存的赏品列表
            </div>
            <el-table
              :data="prizeList"
              border
              stripe
              size="mini"
              style="width: 100%"
            >
              <el-table-column label="ID" prop="id" width="70" align="center" />
              <el-table-column
                label="箱数"
                prop="box"
                width="80"
                align="center"
              />
              <el-table-column
                label="商品ID"
                prop="goods_id"
                width="100"
                align="center"
              />

              <el-table-column label="商品图片" width="100" align="center">
                <template slot-scope="scope">
                  <img
                    :src="scope.row.goods_image"
                    style="width: 60px; height: 60px; object-fit: cover"
                  />
                </template>
              </el-table-column>

              <el-table-column
                label="赏品名称"
                prop="goods_title"
                min-width="260"
              />
              <el-table-column
                label="等级名称"
                prop="level_name"
                width="120"
                align="center"
              />

              <el-table-column
                label="原始数量"
                prop="origin_num"
                width="100"
                align="center"
              />
              <el-table-column
                label="剩余数量"
                prop="num"
                width="100"
                align="center"
              />

              <el-table-column label="原始概率(%)" width="130" align="center">
                <template slot-scope="scope">{{
                  Number(scope.row.origin_probability).toFixed(2)
                }}</template>
              </el-table-column>
              <el-table-column label="当前概率(%)" width="130" align="center">
                <template slot-scope="scope">{{
                  Number(scope.row.probability).toFixed(2)
                }}</template>
              </el-table-column>

              <el-table-column label="价格" width="100" align="center">
                <template slot-scope="scope">{{
                  Number(scope.row.price).toFixed(2)
                }}</template>
              </el-table-column>
              <el-table-column label="回收价" width="100" align="center">
                <template slot-scope="scope">{{
                  Number(scope.row.recovery_price).toFixed(2)
                }}</template>
              </el-table-column>

              <el-table-column label="商品类型" width="90" align="center">
                <template slot-scope="scope">
                  {{ scope.row.goods_type == 1 ? "真实赏品" : "虚拟赏品" }}
                </template>
              </el-table-column>
              <el-table-column label="状态" width="90" align="center">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.is_finish ? 'success' : 'info'">
                    {{ scope.row.is_finish ? "已开" : "未开" }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="创建时间" prop="created_at" width="160" />
              <el-table-column label="更新时间" prop="updated_at" width="160" />

              <el-table-column
                label="操作"
                width="140"
                align="center"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    icon="el-icon-edit"
                    @click.stop="openEditPrizeDialog(scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    icon="el-icon-delete"
                    style="color: #f56c6c"
                    @click.stop="deleteBoxPrize(scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>

            <el-pagination
              @size-change="handlePrizeSizeChange"
              @current-change="handlePrizeCurrentChange"
              :current-page="prizeSearch.page"
              :page-size="prizeSearch.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="prizeTotal"
              style="margin-top: 15px; text-align: right"
            ></el-pagination>
          </div>

          <div slot="footer" style="text-align: right">
            <el-button @click="prizeDialogVisible = false">关闭</el-button>
            <el-button
              type="primary"
              icon="el-icon-document-checked"
              @click="saveBoxPrize"
            >
              保存提交
            </el-button>
          </div>
        </el-dialog>

        <!-- PC 编辑赏品弹窗 -->
        <el-dialog
          title="编辑赏品"
          :visible.sync="editPrizeDialogVisible"
          width="500px"
          append-to-body
        >
          <el-form
            :model="editPrizeForm"
            ref="editPrizeFormRef"
            label-width="100px"
          >
            <el-form-item label="赏品图片">
              <img
                :src="editPrizeForm.goods_image"
                style="width: 60px; height: 60px; object-fit: cover"
              />
            </el-form-item>
            <el-form-item label="赏品名称">
              <el-input v-model="editPrizeForm.goods_title" disabled />
            </el-form-item>
            <el-form-item label="商品ID">
              <el-input v-model="editPrizeForm.goods_id" disabled />
            </el-form-item>

            <el-form-item label="原始数量">
              <el-input
                v-model.number="editPrizeForm.origin_num"
                type="number"
                placeholder="请输入原始数量"
              />
            </el-form-item>
            <el-form-item label="概率(%)">
              <el-input
                v-model.number="editPrizeForm.probability"
                type="number"
                placeholder="请输入概率"
              />
            </el-form-item>
            <el-form-item label="价格">
              <el-input
                v-model.number="editPrizeForm.price"
                type="number"
                placeholder="请输入价格"
              />
            </el-form-item>
            <el-form-item label="回收价">
              <el-input
                v-model.number="editPrizeForm.recovery_price"
                type="number"
                placeholder="请输入回收价"
              />
            </el-form-item>

            <el-form-item label="等级">
              <el-select
                v-model="editPrizeForm.level_id"
                placeholder="选择等级"
              >
                <el-option
                  v-for="item in levelList"
                  :key="item.level_id"
                  :label="item.name"
                  :value="item.level_id"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="商品类型">
              <span>{{
                editPrizeForm.goods_type == 1 ? "真实赏品" : "虚拟赏品"
              }}</span>
            </el-form-item>
          </el-form>

          <div slot="footer">
            <el-button @click="editPrizeDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitEditPrize"
              >确认保存</el-button
            >
          </div>
        </el-dialog>
        <!-- PC 擂台赏抽奖记录弹窗 -->
        <el-dialog
          title="擂台赏抽奖记录"
          :visible.sync="drawRecordVisible"
          width="1400px"
          append-to-body
          close-on-click-modal="false"
        >
          <div
            style="
              display: flex;
              gap: 10px;
              align-items: center;
              margin-bottom: 15px;
            "
          >
            <el-input
              v-model.number="drawRecordSearch.box"
              placeholder="输入箱数搜索"
              style="width: 200px"
              clearable
            ></el-input>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="getDrawRecordList"
              >搜索</el-button
            >
            <el-button icon="el-icon-refresh" @click="resetDrawRecordSearch"
              >重置</el-button
            >
          </div>
          <div v-loading="drawRecordLoading">
            <el-table
              :data="drawRecordList"
              border
              stripe
              size="small"
              style="width: 100%"
            >
              <el-table-column label="ID" prop="id" width="70" align="center" />
              <el-table-column label="用户信息" width="160" align="center">
                <template slot-scope="scope">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      gap: 8px;
                      justify-content: center;
                    "
                  >
                    <img
                      :src="scope.row.avatar"
                      style="
                        width: 36px;
                        height: 36px;
                        border-radius: 50%;
                        object-fit: cover;
                      "
                    />
                    <span>{{ scope.row.nickname }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="箱数"
                prop="box"
                width="80"
                align="center"
              />
              <el-table-column label="赏品图片" width="100" align="center">
                <template slot-scope="scope">
                  <img
                    :src="scope.row.box_prize_image"
                    style="width: 60px; height: 60px; object-fit: cover"
                  />
                </template>
              </el-table-column>
              <el-table-column
                label="赏品名称"
                prop="box_prize_name"
                min-width="220"
              />
              <el-table-column
                label="赏品等级"
                prop="level_name"
                width="100"
                align="center"
              />
              <el-table-column
                label="单价"
                prop="price"
                width="90"
                align="center"
              />
              <el-table-column
                label="回收价"
                prop="recovery_price"
                width="90"
                align="center"
              />
              <el-table-column
                label="抽中次数"
                prop="times"
                width="90"
                align="center"
              />
              <el-table-column
                label="创建时间"
                prop="created_at"
                width="170"
                align="center"
              />
            </el-table>
            <el-pagination
              @size-change="handleDrawRecordSizeChange"
              @current-change="handleDrawRecordCurrentChange"
              :current-page="drawRecordSearch.page"
              :page-size="drawRecordSearch.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="drawRecordTotal"
              style="margin-top: 15px; text-align: right"
            ></el-pagination>
          </div>
          <div slot="footer">
            <el-button @click="drawRecordVisible = false">关闭</el-button>
          </div>
        </el-dialog>
        <!-- PC 选择赏品弹窗 -->
        <el-dialog
          title="选择商品（可多选）"
          :visible.sync="goodsLibraryVisible"
          width="1200px"
          append-to-body
        >
          <div v-loading="goodsLoading" style="padding: 10px">
            <div
              style="
                display: flex;
                gap: 10px;
                margin-bottom: 15px;
                align-items: center;
              "
            >
              <el-input
                v-model="goodsSearch.title"
                placeholder="商品名称"
                style="width: 240px"
                clearable
              ></el-input>

              <el-select
                v-model="goodsSearch.type"
                placeholder="盲盒类型"
                style="width: 180px"
                clearable
                @change="handleGoodsTypeChange"
              >
                <el-option
                  v-for="item in goodsTypeSelectOptions"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>

              <el-select
                v-model="goodsSearch.level_id"
                placeholder="等级筛选"
                style="width: 180px"
                clearable
              >
                <el-option
                  v-for="item in goodsLevelOptions"
                  :key="item.level_id"
                  :label="item.name"
                  :value="item.level_id"
                />
              </el-select>

              <el-button
                type="primary"
                icon="el-icon-search"
                @click="getGoodsList"
                >搜索</el-button
              >
              <el-button icon="el-icon-refresh" @click="resetGoodsSearch"
                >重置</el-button
              >
            </div>

            <el-table
              ref="goodsTable"
              :data="goodsList"
              border
              size="small"
              @selection-change="handleGoodsSelectionChange"
              @row-click="handleGoodsRowClick"
            >
              <el-table-column type="selection" width="55" />
              <el-table-column label="ID" prop="id" width="80" align="center" />
              <el-table-column label="商品图片" width="100" align="center">
                <template slot-scope="scope">
                  <img
                    :src="scope.row.image"
                    style="width: 50px; height: 50px; object-fit: cover"
                  />
                </template>
              </el-table-column>
              <el-table-column label="商品名称" prop="title" min-width="250" />
              <el-table-column
                label="等级"
                prop="level_name"
                width="120"
                align="center"
              />
              <el-table-column
                label="价格"
                prop="price"
                width="100"
                align="center"
              />
              <el-table-column label="商品类型" width="140" align="center">
                <template slot-scope="scope">
                  {{ scope.row.goods_type == 1 ? "真实赏品" : "虚拟赏品" }}
                </template>
              </el-table-column>
              <el-table-column label="创建时间" prop="created_at" width="160" />
            </el-table>

            <el-pagination
              @size-change="handleGoodsSizeChange"
              @current-change="handleGoodsCurrentChange"
              :current-page="goodsSearch.page"
              :page-size="goodsSearch.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="goodsTotal"
              style="margin-top: 15px; text-align: right"
            ></el-pagination>
          </div>
          <div slot="footer">
            <el-button @click="goodsLibraryVisible = false">取消</el-button>
            <el-button type="success" @click="confirmSelectGoods"
              >确认添加选中</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端（全新重写） ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-goods-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <!-- 搜索栏 -->
        <div class="mobile-search-group">
          <el-input
            v-model="searchParams.name"
            placeholder="擂台赏名称"
            clearable
            size="medium"
            prefix-icon="el-icon-search"
          />
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-select
              v-model.number="searchParams.cate_id"
              placeholder="擂台赏分类"
              clearable
              size="medium"
              style="flex: 1"
            >
              <el-option
                v-for="item in cateList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="primary"
              plain
              round
              @click="getList"
              style="flex: 1"
              >搜索</el-button
            >
            <el-button plain round @click="resetSearch" style="flex: 1"
              >重置</el-button
            >
          </div>
        </div>

        <!-- 卡片列表 -->
        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="openMobileDetail(item)"
          >
            <div class="card-header">
              <img :src="item.image" class="avatar" />
              <div class="info">
                <div class="title">{{ item.name }}</div>
                <div class="meta">
                  ID:{{ item.id }} | {{ item.cate_name }} | 售价¥{{
                    item.price
                  }}
                </div>
              </div>
              <div class="status" :class="item.status == 1 ? 'on' : 'off'">
                {{ item.status == 1 ? "上架" : "下架" }}
              </div>
            </div>
            <div class="card-body">
              <div>销量：{{ item.sales }}</div>
              <div>空包：{{ item.empty_num }} | 串数：{{ item.bunch_num }}</div>
              <div>剩余：{{ item.remainText }}</div>
              <div>
                利润：
                <span v-if="Number(item.income) === 0">--</span>
                <span
                  v-else
                  :style="{
                    color: item.income - item.pay >= 0 ? '#00c48c' : '#f56c6c',
                  }"
                >
                  {{
                    (((item.income - item.pay) / item.income) * 100).toFixed(2)
                  }}%
                </span>
              </div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="openMobileEdit(item.id)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="success"
                round
                @click.stop="openMobileRenewBox(item)"
                >续箱</el-button
              >
              <el-switch
                v-model="item.status"
                size="mini"
                active-text="上架"
                inactive-text="下架"
                :active-value="1"
                :inactive-value="0"
                @click.native.stop
                @change="handleStatusChange(item)"
              />
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageTotal"
            pager-count="2"
            small
          />
        </div>

        <!-- 移动端独立详情弹窗 -->
        <el-dialog
          title="擂台赏详情"
          :visible.sync="mobileDetailVisible"
          width="95%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div v-if="mobileDetailRow" style="padding: 10px 0">
            <div style="text-align: center; margin-bottom: 15px">
              <img
                :src="mobileDetailRow.image"
                style="
                  width: 120px;
                  height: 120px;
                  object-fit: cover;
                  border-radius: 8px;
                "
              />
            </div>
            <el-descriptions :column="1" border size="small">
              <el-descriptions-item label="ID">{{
                mobileDetailRow.id
              }}</el-descriptions-item>
              <el-descriptions-item label="名称">{{
                mobileDetailRow.name
              }}</el-descriptions-item>
              <el-descriptions-item label="分类">{{
                mobileDetailRow.cate_name
              }}</el-descriptions-item>
              <el-descriptions-item label="价格"
                >¥{{ mobileDetailRow.price }}</el-descriptions-item
              >
              <el-descriptions-item label="销量">{{
                mobileDetailRow.sales
              }}</el-descriptions-item>
              <el-descriptions-item label="利润">
                <span v-if="Number(mobileDetailRow.income) === 0">--</span>
                <span
                  v-else
                  :style="{
                    color:
                      mobileDetailRow.income - mobileDetailRow.pay >= 0
                        ? '#00C48C'
                        : '#F56C6C',
                  }"
                >
                  {{
                    (
                      ((mobileDetailRow.income - mobileDetailRow.pay) /
                        mobileDetailRow.income) *
                      100
                    ).toFixed(2)
                  }}%
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="空车数">{{
                mobileDetailRow.empty_num
              }}</el-descriptions-item>
              <el-descriptions-item label="串数">{{
                mobileDetailRow.bunch_num
              }}</el-descriptions-item>
              <el-descriptions-item label="剩余时间">{{
                mobileDetailRow.remainText
              }}</el-descriptions-item>
              <el-descriptions-item label="状态">
                <span
                  :style="
                    mobileDetailRow.status == 1
                      ? 'color:#00C48C'
                      : 'color:#F56C6C'
                  "
                >
                  {{ mobileDetailRow.status == 1 ? "上架" : "下架" }}
                </span>
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button @click="mobileDetailVisible = false">关闭</el-button>
          </div>
        </el-dialog>

        <!-- 移动端独立编辑弹窗 -->
        <el-dialog
          title="编辑擂台赏"
          :visible.sync="mobileEditVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            :model="mobileEditForm"
            :rules="mobileAddRules"
            ref="mobileEditRef"
            label-width="90px"
            size="small"
          >
            <el-form-item label="名称" prop="name">
              <el-input
                v-model="mobileEditForm.name"
                placeholder="名称"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="分类" prop="cate_id">
              <el-select
                v-model.number="mobileEditForm.cate_id"
                placeholder="分类"
                size="medium"
              >
                <el-option
                  v-for="item in cateList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="图片">
              <div style="display: flex; align-items: center; gap: 10px">
                <el-button
                  type="primary"
                  size="mini"
                  @click="mobileOpenImageDialog"
                  >选择图片</el-button
                >
                <div
                  v-if="mobileEditForm.image"
                  style="
                    border: 1px solid #eee;
                    padding: 2px;
                    border-radius: 4px;
                  "
                >
                  <img
                    :src="mobileEditForm.image"
                    style="width: 46px; height: 46px; object-fit: cover"
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="价格" prop="price">
              <el-input
                v-model="mobileEditForm.price"
                placeholder="价格"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="卡册门票ID" prop="goods_id">
              <el-input
                v-model.number="mobileEditForm.goods_id"
                placeholder="卡册门票ID"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="空车数" prop="empty_num">
              <el-input
                v-model="mobileEditForm.empty_num"
                placeholder="空车数"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="串数" prop="bunch_num">
              <el-input
                v-model="mobileEditForm.bunch_num"
                placeholder="串数"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input
                v-model="mobileEditForm.sort"
                placeholder="排序"
                size="medium"
              />
            </el-form-item>

            <el-form-item label="定制人ID">
              <el-input
                v-model="mobileEditForm.custom_user_id"
                placeholder="可选"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="定制天数">
              <el-input
                v-model="mobileEditForm.custom_days"
                placeholder="可选"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="定制开始">
              <el-date-picker
                v-model="mobileEditForm.custom_start"
                type="datetime"
                placeholder="开始时间"
                size="medium"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="mobilePickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="定制结束">
              <el-date-picker
                v-model="mobileEditForm.custom_end"
                type="datetime"
                placeholder="结束时间"
                size="medium"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="mobileEndPickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-form>

          <div
            slot="footer"
            style="
              text-align: right;
              display: flex;
              justify-content: flex-end;
              gap: 10px;
            "
          >
            <el-button size="medium" @click="mobileEditVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="medium" @click="submitMobileEdit"
              >保存</el-button
            >
          </div>
        </el-dialog>

        <!-- 移动端续箱弹窗 -->
        <el-dialog
          title="擂台续箱"
          :visible.sync="mobileRenewVisible"
          width="90%"
          top="15vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            :model="mobileRenewForm"
            ref="mobileRenewRef"
            label-width="90px"
            size="small"
          >
            <el-form-item label="擂台ID">
              <el-input
                v-model="mobileRenewForm.box_id"
                disabled
                size="medium"
              />
            </el-form-item>
            <el-form-item label="擂台名称">
              <el-input
                v-model="mobileRenewForm.box_name"
                disabled
                size="medium"
              />
            </el-form-item>
            <el-form-item label="续箱数量" prop="num">
              <el-input
                v-model.number="mobileRenewForm.num"
                type="number"
                placeholder="请输入续箱数量"
                min="1"
                size="medium"
              />
            </el-form-item>
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button size="mini" @click="mobileRenewVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="mini" @click="submitMobileRenew"
              >确认续箱</el-button
            >
          </div>
        </el-dialog>

        <!-- 移动端独立图片选择弹窗 -->
        <el-dialog
          title="选择图片"
          :visible.sync="mobileImageDialogVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div
            v-loading="mobileImageLoading"
            element-loading-text="加载中..."
            style="padding: 5px"
          >
            <div style="display: flex; gap: 8px; margin-bottom: 10px">
              <el-select
                v-model.number="mobileImageSearch.type"
                placeholder="类型"
                size="mini"
                clearable
                style="flex: 1"
              >
                <el-option
                  v-for="item in mobileImageType"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
              <el-button size="mini" type="primary" @click="mobileGetImageList"
                >筛选</el-button
              >
              <el-button size="mini" @click="mobileResetImageSearch"
                >重置</el-button
              >
            </div>

            <div
              style="
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                max-height: 45vh;
                overflow-y: auto;
                padding: 5px;
              "
            >
              <div
                v-for="img in mobileImageList"
                :key="img.id"
                @click="mobileSelectImage(img)"
                style="
                  padding: 3px;
                  border-radius: 6px;
                  cursor: pointer;
                  text-align: center;
                "
                :style="{
                  border:
                    mobileSelectedImageUrl == img.url
                      ? '2px solid #1989fa'
                      : '2px solid transparent',
                  background:
                    mobileSelectedImageUrl == img.url
                      ? '#f0f7ff'
                      : 'transparent',
                }"
              >
                <img
                  :src="img.url"
                  style="
                    width: 70px;
                    height: 70px;
                    object-fit: cover;
                    border-radius: 4px;
                    display: block;
                  "
                />
                <span
                  style="
                    font-size: 12px;
                    color: #666;
                    margin-top: 3px;
                    display: block;
                  "
                >
                  {{ mobileGetImageTypeName(img.type) }}
                </span>
              </div>
            </div>

            <div style="margin-top: 10px; text-align: center">
              <el-pagination
                @size-change="mobileHandleImageSizeChange"
                @current-change="mobileHandleImageCurrentChange"
                :current-page="mobileImageSearch.page"
                :page-size="mobileImageSearch.page_size"
                layout="prev, pager, next"
                :total="mobileImageTotal"
                pager-count="2"
                small
              />
            </div>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button size="mini" @click="mobileImageDialogVisible = false"
              >取消</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="mobileConfirmSelectImage"
              >确认</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "ChallengeBoxTable",
  data() {
    return {
      // ====================== PC 独立数据 ======================
      loading: false,
      tableData: [],
      pageTotal: 0,
      cateList: [],
      levelList: [],
      searchParams: { page: 1, page_size: 10, name: "", cate_id: "" },
      columnOptions: [
        { label: "ID", prop: "id" },
        { label: "擂台赏名称", prop: "name" },
        { label: "擂台赏图片", prop: "image" },
        { label: "价格", prop: "price" },
        { label: "分类名称", prop: "cate_name" },
        { label: "销量", prop: "sales" },
        { label: "空车数", prop: "empty_num" },
        { label: "串数", prop: "bunch_num" },
        { label: "收入", prop: "income" },
        { label: "支出", prop: "pay" },
        { label: "利润", prop: "profit" }, // 新增
        { label: "排序", prop: "sort" },
        { label: "定制人ID", prop: "custom_user_id" },
        { label: "剩余时间", prop: "remainText" },
        { label: "定制开始", prop: "custom_start" },
        { label: "定制结束", prop: "custom_end" },
        { label: "状态", prop: "status" },
        { label: "创建时间", prop: "created_at" },
        { label: "更新时间", prop: "updated_at" },
        { label: "操作", prop: "action" },
      ],
      checkedColumns: [
        "id",
        "name",
        "image",
        "price",
        "cate_name",
        "sales",
        "empty_num",
        "bunch_num",
        "income",
        "pay",
        "profit", // 默认勾选显示
        "sort",
        "custom_user_id",
        "remainText",
        "custom_start",
        "custom_end",
        "status",
        "created_at",
        "updated_at",
        "action",
      ],
      dialogVisible: false,
      dialogType: "add",
      form: {
        box_id: "",
        name: "",
        cate_id: "",
        image: "",
        sort: "",
        empty_num: "",
        price: "",
        bunch_num: "",
        custom_user_id: "",
        custom_days: "",
        custom_start: "",
        custom_end: "",
        goods_id: "",
      },
      addRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        cate_id: [{ required: true, message: "请选择分类", trigger: "change" }],
        image: [{ required: true, message: "请选择图片", trigger: "change" }],
        price: [{ required: true, message: "请输入价格", trigger: "blur" }],
        empty_num: [
          { required: true, message: "请输入空车数", trigger: "blur" },
        ],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        bunch_num: [{ required: true, message: "请输入串值", trigger: "blur" }],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 3600 * 1000;
        },
      },
      endPickerOptions: {
        disabledDate: (time) => {
          if (!this.form.custom_start)
            return time.getTime() < Date.now() - 24 * 3600 * 1000;
          return time.getTime() < new Date(this.form.custom_start).getTime();
        },
      },
      imageDialogVisible: false,
      imageLoading: false,
      imageList: [],
      imageTotal: 0,
      image_type: [],
      imageSearch: { page: 1, page_size: 10, type: "" },
      selectedImageUrl: "",
      detailDialogVisible: false,
      detailRow: null,
      detailLoading: false,
      timer: null,

      // PC 续箱
      renewBoxVisible: false,
      renewBoxForm: {
        box_id: "",
        box_name: "",
        num: 1,
      },

      // PC 赏品
      prizeDialogVisible: false,
      prizeList: [],
      prizeTotal: 0,
      currentBoxId: "",
      prizeSearch: { page: 1, page_size: 10, box: "", box_id: "" },
      tempSelectedPrize: [],
      editPrizeDialogVisible: false,
      editPrizeForm: {
        prize_id: "",
        origin_num: "",
        probability: "",
        goods_id: "",
        goods_image: "",
        goods_title: "",
        level_id: "",
        price: "",
        recovery_price: "",
        goods_type: "",
      },
      goodsLibraryVisible: false,
      goodsLoading: false,
      goodsList: [],
      goodsTotal: 0,
      goodsSearch: {
        page: 1,
        page_size: 10,
        title: "",
        type: "",
        level_id: "",
        flag: "2",
      },
      goodsTypeSelectOptions: [],
      goodsLevelOptions: [],
      goodsTypeList: [],
      selectedGoodsList: [],
      existGoodsIds: [],
      // 抽奖记录
      drawRecordVisible: false,
      drawRecordLoading: false,
      drawRecordList: [],
      drawRecordTotal: 0,
      currentDrawBoxId: "",
      drawRecordSearch: {
        page: 1,
        page_size: 10,
        box: "",
        type: 2,
        box_id: "",
      },
      // ====================== 移动端独立数据 ======================
      mobileDetailVisible: false,
      mobileDetailRow: null,
      mobileEditVisible: false,
      mobileEditForm: {
        box_id: "",
        name: "",
        cate_id: "",
        image: "",
        price: "",
        empty_num: "",
        bunch_num: "",
        sort: "",
        custom_user_id: "",
        custom_days: "",
        custom_start: "",
        custom_end: "",
        goods_id: "",
      },
      mobileAddRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        cate_id: [{ required: true, message: "请选择分类", trigger: "change" }],
        image: [{ required: true, message: "请选择图片", trigger: "change" }],
        price: [{ required: true, message: "请输入价格", trigger: "blur" }],
        empty_num: [
          { required: true, message: "请输入空车数", trigger: "blur" },
        ],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        bunch_num: [{ required: true, message: "请输入串值", trigger: "blur" }],
      },
      mobilePickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 3600 * 1000;
        },
      },
      mobileEndPickerOptions: {
        disabledDate: (time) => {
          if (!this.mobileEditForm.custom_start)
            return time.getTime() < Date.now() - 24 * 3600 * 1000;
          return (
            time.getTime() <
            new Date(this.mobileEditForm.custom_start).getTime()
          );
        },
      },
      mobileImageDialogVisible: false,
      mobileImageLoading: false,
      mobileImageList: [],
      mobileImageTotal: 0,
      mobileImageType: [],
      mobileImageSearch: { page: 1, page_size: 10, type: "" },
      mobileSelectedImageUrl: "",

      // 移动端续箱
      mobileRenewVisible: false,
      mobileRenewForm: {
        box_id: "",
        box_name: "",
        num: 1,
      },
    };
  },
  created() {
    this.getList();
  },
  mounted() {
    this.startRealTimeRefresh();
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    // ====================== PC 续箱方法 ======================
    openRenewBox(row) {
      this.renewBoxForm = {
        box_id: row.id,
        box_name: row.name,
        num: 1,
      };
      this.renewBoxVisible = true;
    },
    async submitRenewBox() {
      if (!this.renewBoxForm.num || this.renewBoxForm.num < 1) {
        return this.$message.error("续箱数量必须大于0");
      }
      this.loading = true;
      try {
        const res = await api.challengeBox.renewBox({
          box_id: this.renewBoxForm.box_id,
          num: this.renewBoxForm.num,
        });
        if (res.data.code == 1000) {
          this.renewBoxVisible = false;
          this.getList();
        }
      } catch (err) {
      } finally {
        this.loading = false;
      }
    },

    // ====================== PC 独立方法 ======================
    getList() {
      this.loading = true;
      api.challengeBox
        .index({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == "1000") {
            this.tableData = res.data.data.data;
            this.cateList = res.data.data.cate;
            this.levelList = res.data.data.level;
            this.pageTotal = res.data.data.total;
            this.updateRemainText();
          }
        })
        .finally(() => (this.loading = false));
    },
    submitForm() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        try {
          this.dialogType == "add"
            ? await api.challengeBox.add(this.form)
            : await api.challengeBox.edit(this.form);
          this.dialogVisible = false;
          this.getList();
        } finally {
          this.loading = false;
        }
      });
    },
    async handleStatusChange(row) {
      const params = { box_id: row.id, status: row.status };
      try {
        await api.challengeBox.status(params);
        this.getList();
      } catch (err) {
        row.status = row.status == 1 ? 0 : 1;
      }
    },
    async handleEdit(row) {
      this.dialogType = "edit";
      this.dialogVisible = true;
      this.resetForm();
      this.form = {
        box_id: row.id,
        name: row.name || "",
        cate_id: row.cate_id || "",
        image: row.image || "",
        sort: row.sort || "",
        empty_num: row.empty_num || "",
        price: row.price || "",
        bunch_num: row.bunch_num || "",
        custom_user_id: row.custom_user_id || "",
        custom_days: row.custom_days || "",
        custom_start: row.custom_start || "",
        custom_end: row.custom_end || "",
        goods_id: row.goods_id || "", // 新增
      };
    },
    handleAdd() {
      this.dialogType = "add";
      this.resetForm();
      this.dialogVisible = true;
    },
    resetForm() {
      this.form = {
        box_id: "",
        name: "",
        cate_id: "",
        image: "",
        sort: "",
        empty_num: "",
        price: "",
        bunch_num: "",
        custom_user_id: "",
        custom_days: "",
        custom_start: "",
        custom_end: "",
        goods_id: "", // 新增
      };
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate();
      });
    },
    updateRemainText() {
      const now = Date.now();
      this.tableData.forEach((row) => {
        if (!row.custom_end) {
          row.remainText = "—";
          return;
        }
        const diff = new Date(row.custom_end).getTime() - now;
        if (diff <= 0) {
          row.remainText = "已结束";
          return;
        }
        const d = Math.floor(diff / 86400000);
        const h = Math.floor((diff % 86400000) / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        row.remainText = `${d}天 ${h}时 ${m}分 ${s}秒`;
      });
    },
    startRealTimeRefresh() {
      this.timer = setInterval(() => this.updateRemainText(), 1000);
    },
    async handleRowClick(row) {
      this.detailLoading = true;
      this.detailRow = { ...row };
      this.detailDialogVisible = true;
      this.detailLoading = false;
    },
    resetSearch() {
      this.searchParams = { page: 1, page_size: 10, name: "", cate_id: "" };
      this.getList();
    },
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
    handleCheckAll() {
      this.checkedColumns = this.columnOptions.map((i) => i.prop);
    },
    handleClearAll() {
      this.checkedColumns = [];
    },
    openImageDialog() {
      this.imageDialogVisible = true;
      this.selectedImageUrl = "";
      this.getImageList();
    },
    getImageList() {
      this.imageLoading = true;
      api.images
        .index({ params: this.imageSearch })
        .then((res) => {
          if (res.data.code == 1000) {
            this.imageList = res.data.data.data || [];
            this.imageTotal = res.data.data.total || 0;
            this.image_type = res.data.data.image_type || [];
          }
        })
        .finally(() => (this.imageLoading = false));
    },
    selectImage(img) {
      this.selectedImageUrl = img.url;
    },
    confirmSelectImage() {
      if (!this.selectedImageUrl) return this.$message.warning("请选择图片");
      this.form.image = this.selectedImageUrl;
      this.imageDialogVisible = false;
    },
    resetImageSearch() {
      this.imageSearch = { page: 1, page_size: 10, type: "" };
      this.getImageList();
    },
    handleImageSizeChange(val) {
      this.imageSearch.page_size = val;
      this.getImageList();
    },
    handleImageCurrentChange(val) {
      this.imageSearch.page = val;
      this.getImageList();
    },
    getImageTypeName(type) {
      const item = this.image_type.find((t) => t.type == type);
      return item ? item.desc : "未知";
    },
    openPrizeDialog(row) {
      if (this.currentBoxId !== row.id) this.tempSelectedPrize = [];
      this.currentBoxId = row.id;
      this.prizeSearch.box_id = row.id;
      this.resetPrizeSearch();
      this.prizeDialogVisible = true;
    },
    getPrizeList() {
      this.loading = true;
      api.challengeBox
        .boxList({ params: this.prizeSearch })
        .then((res) => {
          if (res.data.code == "1000") {
            this.prizeList = res.data.data.data;
            this.prizeTotal = res.data.data.total;
          }
        })
        .finally(() => (this.loading = false));
    },
    resetPrizeSearch() {
      this.prizeSearch = {
        page: 1,
        page_size: 10,
        box: "",
        box_id: this.currentBoxId,
      };
      this.getPrizeList();
    },
    handlePrizeSizeChange(val) {
      this.prizeSearch.page_size = val;
      this.getPrizeList();
    },
    handlePrizeCurrentChange(val) {
      this.prizeSearch.page = val;
      this.getPrizeList();
    },
    openGoodsDialog() {
      this.goodsLibraryVisible = true;
      this.selectedGoodsList = [];
      this.existGoodsIds = this.tempSelectedPrize.map((item) => item.goods_id);
      this.resetGoodsSearch();
    },
    getGoodsList() {
      this.goodsLoading = true;
      api.goods
        .index({ params: this.goodsSearch })
        .then((res) => {
          if (res.data.code == 1000) {
            this.goodsList = res.data.data.data || [];
            this.goodsTotal = res.data.data.total || 0;
            this.goodsTypeSelectOptions = res.data.data.goods_level || [];
            this.goodsTypeList = res.data.data.goods_type || [];
            this.$nextTick(() => {
              if (!this.$refs.goodsTable) return;
              this.$refs.goodsTable.clearSelection();
              this.goodsList.forEach((row) => {
                if (this.existGoodsIds.includes(row.id)) {
                  this.$refs.goodsTable.toggleRowSelection(row, true);
                }
              });
            });
          }
        })
        .finally(() => (this.goodsLoading = false));
    },
    handleGoodsTypeChange(type) {
      if (!type) {
        this.goodsLevelOptions = [];
        this.goodsSearch.level_id = "";
        return;
      }
      const target = this.goodsTypeSelectOptions.find(
        (item) => item.type == type
      );
      this.goodsLevelOptions = target ? target.goods_level : [];
      this.goodsSearch.level_id = "";
    },
    handleGoodsSelectionChange(val) {
      this.selectedGoodsList = val;
    },
    handleGoodsRowClick(row) {
      this.$refs.goodsTable.toggleRowSelection(row);
    },
    confirmSelectGoods() {
      if (!this.selectedGoodsList.length)
        return this.$message.warning("请选择商品");

      this.selectedGoodsList.forEach((item) => {
        // 新增：获取商品类型（默认1真实）
        const goodsType = item.goods_type || 1;

        // 规则：只有 非虚拟商品(≠2) 才需要去重
        let canAdd = true;
        if (goodsType !== 2) {
          const isExist = this.tempSelectedPrize.some(
            (i) => i.goods_id == item.id
          );
          if (isExist) {
            canAdd = false;
          }
        }

        if (canAdd) {
          this.tempSelectedPrize.push({
            goods_id: item.id,
            title: item.title,
            image: item.image,
            level_id: item.level_id,
            level_name: item.level_name,
            price: item.price || 0,
            recovery_price: item.price || 0,
            goods_type: goodsType, // 这里也自动带上类型，更准确
          });
        }
      });

      this.goodsLibraryVisible = false;
    },
    delTempPrize(row) {
      this.tempSelectedPrize = this.tempSelectedPrize.filter(
        (item) => item.goods_id != row.goods_id
      );
    },
    resetGoodsSearch() {
      this.goodsSearch = {
        page: 1,
        page_size: 10,
        title: "",
        type: "",
        level_id: "",
        flag: 2,
      };
      this.goodsLevelOptions = [];
      this.getGoodsList();
    },
    handleGoodsSizeChange(val) {
      this.goodsSearch.page_size = val;
      this.getGoodsList();
    },
    handleGoodsCurrentChange(val) {
      this.goodsSearch.page = val;
      this.getGoodsList();
    },
    openEditPrizeDialog(row) {
      this.editPrizeForm = {
        prize_id: row.id,
        origin_num: row.origin_num,
        probability: parseFloat(row.probability),
        goods_id: row.goods_id,
        goods_image: row.goods_image,
        goods_title: row.goods_title,
        level_id: row.level_id,
        price: parseFloat(row.price),
        recovery_price: parseFloat(row.recovery_price),
        goods_type: row.goods_type,
      };
      this.editPrizeDialogVisible = true;
    },
    async submitEditPrize() {
      this.loading = true;
      try {
        const res = await api.challengeBox.editBoxPrize(this.editPrizeForm);
        if (res.data.code == 1000) {
          this.editPrizeDialogVisible = false;
          this.getPrizeList();
        }
      } catch (err) {
      } finally {
        this.loading = false;
      }
    },
    async deleteBoxPrize(row) {
      const confirm = await this.$confirm("确定删除该赏品？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch(() => false);
      if (!confirm) return;
      this.loading = true;
      try {
        const res = await api.challengeBox.delBoxPrize({ prize_id: row.id });
        if (res.data.code == 1000) this.getPrizeList();
      } catch (err) {
      } finally {
        this.loading = false;
      }
    },
    async saveBoxPrize() {
      if (!this.currentBoxId) return this.$message.warning("请先选择擂台赏");
      if (this.tempSelectedPrize.length == 0)
        return this.$message.warning("请先添加待提交赏品");
      for (let i = 0; i < this.tempSelectedPrize.length; i++) {
        const item = this.tempSelectedPrize[i];
        const name = item.title || `第${i + 1}个赏品`;
        if (!item.num && item.num !== 0)
          return this.$message.error(`${name}：原始数量不能为空`);
        if (!item.probability && item.probability !== 0)
          return this.$message.error(`${name}：概率不能为空`);
        if (!item.price && item.price !== 0)
          return this.$message.error(`${name}：价格不能为空`);
        if (!item.recovery_price && item.recovery_price !== 0)
          return this.$message.error(`${name}：兑换价格不能为空`);
        if (!item.goods_type)
          return this.$message.error(`${name}：请选择赏品类型`);
        if (!item.level_id) return this.$message.error(`${name}：请选择等级`);
      }
      const prize_info = this.tempSelectedPrize.map((item) => ({
        goods_id: item.goods_id,
        probability: item.probability || 0,
        origin_num: item.num || 1,
        level_id: item.level_id,
        price: item.price || 0,
        recovery_price: item.recovery_price || 0,
        goods_type: item.goods_type || 1,
      }));
      const params = {
        box_id: this.currentBoxId,
        prize_info: JSON.stringify(prize_info),
      };
      this.loading = true;
      try {
        const res = await api.challengeBox.addBoxPrize(params);
        if (res.data.code == 1000) {
          this.tempSelectedPrize = [];
          this.getPrizeList();
        }
      } catch (err) {
      } finally {
        this.loading = false;
      }
    },

    // ====================== 移动端续箱方法 ======================
    openMobileRenewBox(row) {
      this.mobileRenewForm = {
        box_id: row.id,
        box_name: row.name,
        num: 1,
      };
      this.mobileRenewVisible = true;
    },
    async submitMobileRenew() {
      if (!this.mobileRenewForm.num || this.mobileRenewForm.num < 1) {
        return this.$message.error("续箱数量必须大于0");
      }
      this.loading = true;
      try {
        const res = await api.challengeBox.renewBox({
          box_id: this.mobileRenewForm.box_id,
          num: this.mobileRenewForm.num,
        });
        if (res.data.code == 1000) {
          this.mobileRenewVisible = false;
          this.getList();
        }
      } catch (err) {
      } finally {
        this.loading = false;
      }
    },
    // 打开抽奖记录弹窗
    openDrawRecord(row) {
      this.currentDrawBoxId = row.id;
      this.drawRecordSearch.box_id = row.id;
      this.resetDrawRecordSearch();
      this.drawRecordVisible = true;
    },
    // 获取抽奖记录列表
    async getDrawRecordList() {
      this.drawRecordLoading = true;
      try {
        const res = await api.blindCate.boxDrawRecord({
          params: this.drawRecordSearch,
        });
        if (res.data.code === "1000") {
          this.drawRecordList = res.data.data.data;
          this.drawRecordTotal = res.data.data.total;
        }
      } catch (err) {
        this.$message.error("加载抽奖记录失败");
      } finally {
        this.drawRecordLoading = false;
      }
    },
    // 重置抽奖记录搜索
    resetDrawRecordSearch() {
      this.drawRecordSearch = {
        page: 1,
        page_size: 10,
        box: "",
        type: 2,
        box_id: this.currentDrawBoxId,
      };
      this.getDrawRecordList();
    },
    // 分页切换
    handleDrawRecordSizeChange(val) {
      this.drawRecordSearch.page_size = val;
      this.getDrawRecordList();
    },
    handleDrawRecordCurrentChange(val) {
      this.drawRecordSearch.page = val;
      this.getDrawRecordList();
    },
    // ====================== 移动端独立方法 ======================
    openMobileDetail(row) {
      this.mobileDetailRow = JSON.parse(JSON.stringify(row));
      this.mobileDetailVisible = true;
    },
    async openMobileEdit(id) {
      let row = this.tableData.find((item) => item.id == id);
      if (!row) return;
      this.mobileEditVisible = true;
      this.mobileEditForm = {
        box_id: row.id || "",
        name: row.name || "",
        cate_id: row.cate_id || "",
        image: row.image || "",
        sort: row.sort || "",
        empty_num: row.empty_num || "",
        price: row.price || "",
        bunch_num: row.bunch_num || "",
        custom_user_id: row.custom_user_id || "",
        custom_days: row.custom_days || "",
        custom_start: row.custom_start || "",
        custom_end: row.custom_end || "",
        goods_id: row.goods_id || "", // 新增
      };
    },
    async submitMobileEdit() {
      const valid = await this.$refs.mobileEditRef
        .validate()
        .catch(() => false);
      if (!valid) return;
      this.loading = true;
      try {
        const res = await api.challengeBox.edit(this.mobileEditForm);
        if (res.data.code == 1000) {
          this.mobileEditVisible = false;
          this.getList();
        }
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    mobileOpenImageDialog() {
      this.mobileImageDialogVisible = true;
      this.mobileSelectedImageUrl = "";
      this.mobileGetImageList();
    },
    mobileGetImageList() {
      this.mobileImageLoading = true;
      api.images
        .index({ params: this.mobileImageSearch })
        .then((res) => {
          if (res.data.code == 1000) {
            this.mobileImageList = res.data.data.data || [];
            this.mobileImageTotal = res.data.data.total || 0;
            this.mobileImageType = res.data.data.image_type || [];
          }
        })
        .finally(() => (this.mobileImageLoading = false));
    },
    mobileSelectImage(img) {
      this.mobileSelectedImageUrl = img.url;
    },
    mobileConfirmSelectImage() {
      if (!this.mobileSelectedImageUrl)
        return this.$message.warning("请选择图片");
      this.mobileEditForm.image = this.mobileSelectedImageUrl;
      this.mobileImageDialogVisible = false;
    },
    mobileResetImageSearch() {
      this.mobileImageSearch = { page: 1, page_size: 10, type: "" };
      this.mobileGetImageList();
    },
    mobileHandleImageSizeChange(val) {
      this.mobileImageSearch.page_size = val;
      this.mobileGetImageList();
    },
    mobileHandleImageCurrentChange(val) {
      this.mobileImageSearch.page = val;
      this.mobileGetImageList();
    },
    mobileGetImageTypeName(type) {
      const item = this.mobileImageType.find((t) => t.type == type);
      return item ? item.desc : "未知";
    },
  },
};
</script>

<style scoped>
/* ====================== PC 原有样式 ====================== */
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.detail-content {
  padding: 10px 0;
}

/* ====================== 移动端全新样式 ====================== */
.mobile-goods-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.avatar {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  object-fit: cover;
}
.info {
  flex: 1;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.status {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
}
.status.on {
  background: #e6f7ee;
  color: #00c48c;
}
.status.off {
  background: #fef0f0;
  color: #f56c6c;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/challenge/index.vue